export default {
    name: "Transportation Execution",
    meta: {
        icon: "local_shipping ",
        expanded: true,
        auth: true,
    },
    departmentName: "Transportation",
    finalPagePermision: "",

    children: [{
            name: "Execution Details",
            path: "/listView/viewQuotation",
            permissionName: 'Sea Export',
            keywords: ['Transportation Execution', 'Execution Details', 'Transportation'],
            meta: {
                icon: "local_shipping ",
                auth: true,
            },
            component: require("../component/view/listView/viewQuotation.vue"),
            finalPagePermision: "",
        },
        {
            name: "Assignment  Details",
            path: "/listView/viewSalesBooking",
            permissionName: 'Sea Export',
            keywords: ['Transportation Execution', 'Execution Details', 'Assignment  Details', 'Transportation'],
            meta: {
                icon: "local_shipping ",
                auth: true,
            },
            component: require("../component/view/listView/viewSalesBooking.vue"),
            finalPagePermision: "",
        },
        {
            name: "Container Allocation",
            path: "/listView/container-alloc",
            permissionName: 'Sea Export',
            keywords: ['Transportation Execution', 'Execution Details', 'Assignment  Details', 'Transportation','Container Allocation'],
            meta: {
                icon: "local_shipping ",
                auth: true,
            },
            component: require("../component/view/vehicleQuotation/containerAllocationList.vue"),
            finalPagePermision: "",
        },
        {
            name: "Transportation Reports",
            path: "/transport/newTransportationReports",
            permissionName: 'Sea Export',
            keywords: ['Transportation Execution', 'Execution Details', 'Assignment  Details', 'Transportation Reports',
                'Transportation'
            ],
            meta: {
                icon: "local_shipping ",
                auth: true,
            },
            component: require("../component/reports/newTransportationReports.vue"),
            finalPagePermision: "",
        },
        {
            name: "Wheels Track",
            path: "/transport/WheelsTrack",
            permissionName: 'Sea Export',
            keywords: ['Transportation Execution', 'Execution Details', 'Assignment  Details', 'Transportation Reports','Transportation','Wheels Track'
                
            ],
            meta: {
                icon: "local_shipping ",
                auth: true,
            },
            component: require("../component/common/WheelsTrack.vue"),
            finalPagePermision: "",
        },
        
        {
            name: "Daily TPT Expense",
            path: "/transport/tptExpense",
            permissionName: 'Sea Export',
            keywords: ['Transportation Execution', 'Execution Details', 'Assignment  Details', 'Transportation Reports','Transportation','Wheels Track','Daily TPT Expense'],
            meta: {
                icon: "local_shipping ",
                auth: true,
            },
            component: require("../component/expense/dailyTPTExpense.vue"),
            finalPagePermision: "",
        },
        
        {
            name: "GRN Details",
            path: "/transport/GRNdetails",
            permissionName: 'Sea Export',
            keywords: ['Transportation Execution', 'Execution Details', 'Assignment  Details', 'Transportation Reports','Transportation','Wheels Track','Daily TPT Expense', 'GRN Details'],
            meta: {
                icon: "local_shipping ",
                auth: true,
            },
            component: require("../component/expense/GRNdetails.vue"),
            finalPagePermision: "",
        },
         {
            name: "JSON Details",
            path: "/transport/dynamicForm",
            permissionName: 'Sea Export',
            keywords: ['Transportation Execution', 'Execution Details', 'Assignment  Details', 'Transportation Reports','Transportation','Wheels Track','Daily TPT Expense', 'GRN Details'],
            meta: {
                icon: "local_shipping ",
                auth: true,
            },
            component: require("../component/allModuleForm/JsonFormLoader.vue"),
            finalPagePermision: "",
        },
        // {
        //   name: "Invoice Details",
        //   path: "/listView/viewInvoice",
        //   meta: {
        //     auth: true,
        //     // icon: "insert_drive_file"
        //   },
        //   component: require("../component/view/listView/viewInvoice.vue"),

        //   finalPagePermision: "",
        // },
        // {
        //   name: "Transportation Form",
        //   path: "/sales/salesBooking",
        //   meta: {
        //     auth: true
        //   },
        //   component: require("../component/view/sales/salesBookingForm.vue"),
        //   finalPagePermision: "",
        // },
        // {
        //   name: "Enquiry Details",
        //   path: "/view/Enquiry",
        //   meta: {
        //     auth: true
        //   },
        //   component: require("../component/view/listView/viewEnquiryDetail.vue"),
        //   finalPagePermision: "",
        // }
    ],
};


// WEBPACK FOOTER //
// ./src/sidebar/transportation.js